module.exports = __webpack_public_path__ + "static/media/Kalbelauswahl1.8e4880aa.png";